import * as S from "./TextBlock.style";

const TextBlock = ({ children, isPrimaryColor }) => {
  return (
    <S.TextBlock
      variant="headline-01"
      color="white"
      isPrimaryColor={isPrimaryColor}
    >
      {children}
    </S.TextBlock>
  );
};

export default TextBlock;
